/* tslint:disable */
/* eslint-disable */
/**
 * OpenAPI definition
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import { mapValues } from '../runtime';
import type { ClientTermsAndConditionsResource } from './';
import {
    ClientTermsAndConditionsResourceFromJSON,
    ClientTermsAndConditionsResourceFromJSONTyped,
    ClientTermsAndConditionsResourceToJSON,
} from './';

/**
 * 
 * @export
 * @interface AllClientTermsAndConditionsResource
 */
export interface AllClientTermsAndConditionsResource {
    /**
     * 
     * @type {ClientTermsAndConditionsResource}
     * @memberof AllClientTermsAndConditionsResource
     */
    current?: ClientTermsAndConditionsResource;
    /**
     * 
     * @type {Array<ClientTermsAndConditionsResource>}
     * @memberof AllClientTermsAndConditionsResource
     */
    currentTermsAndConditions: Array<ClientTermsAndConditionsResource>;
    /**
     * 
     * @type {Array<ClientTermsAndConditionsResource>}
     * @memberof AllClientTermsAndConditionsResource
     */
    archivedDocuments: Array<ClientTermsAndConditionsResource>;
}

/**
 * Check if a given object implements the AllClientTermsAndConditionsResource interface.
 */
export function instanceOfAllClientTermsAndConditionsResource(value: object): value is AllClientTermsAndConditionsResource {
    if (!('currentTermsAndConditions' in value) || value['currentTermsAndConditions'] === undefined) return false;
    if (!('archivedDocuments' in value) || value['archivedDocuments'] === undefined) return false;
    return true;
}

export function AllClientTermsAndConditionsResourceFromJSON(json: any): AllClientTermsAndConditionsResource {
    return AllClientTermsAndConditionsResourceFromJSONTyped(json, false);
}

export function AllClientTermsAndConditionsResourceFromJSONTyped(json: any, ignoreDiscriminator: boolean): AllClientTermsAndConditionsResource {
    if (json == null) {
        return json;
    }
    return {
        
        'current': json['current'] == null ? undefined : ClientTermsAndConditionsResourceFromJSON(json['current']),
        'currentTermsAndConditions': ((json['currentTermsAndConditions'] as Array<any>).map(ClientTermsAndConditionsResourceFromJSON)),
        'archivedDocuments': ((json['archivedDocuments'] as Array<any>).map(ClientTermsAndConditionsResourceFromJSON)),
    };
}

export function AllClientTermsAndConditionsResourceToJSON(value?: AllClientTermsAndConditionsResource | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'current': ClientTermsAndConditionsResourceToJSON(value['current']),
        'currentTermsAndConditions': ((value['currentTermsAndConditions'] as Array<any>).map((v) => ClientTermsAndConditionsResourceToJSON(v))),
        'archivedDocuments': ((value['archivedDocuments'] as Array<any>).map((v) => ClientTermsAndConditionsResourceToJSON(v))),
    };
}

